import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage, useIntl} from 'react-intl'
import {useHistory} from 'react-router-dom'
import {
    Heading,
    Stack,
    Button,
    useBreakpointValue,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import ResetPasswordForm from '../../components/reset-password'
import {LeftArrow} from '../../components/icons'
import {
    API_ERROR_MESSAGE,
    FEATURE_UNAVAILABLE_ERROR_MESSAGE
} from '@salesforce/retail-react-app/app/constants'
import {useForm} from 'react-hook-form'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {useAuthHelper, AuthHelpers, useAccessToken} from '@salesforce/commerce-sdk-react'
import {sendViewErrorEvent} from '../../utils/gtm-utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const ChangePassword = ({customerEmail}) => {
    const isMobile = useBreakpointValue({base: true, md: false})
    const history = useHistory()
    const {formatMessage} = useIntl()

    const navigate = useNavigation()
    const appOrigin = useAppOrigin()
    const {getTokenWhenReady} = useAccessToken()
    const logout = useAuthHelper(AuthHelpers.Logout)
    const [shouldShowHeading, setShouldShowHeading] = useState(true)
    const {site} = useMultiSite()
    const siteId = site?.id

    const form = useForm({
        defaultValues: {
            email: customerEmail
        }
    })

    const submitForm = async ({email}) => {
        try {
            const token = await getTokenWhenReady()
            const response = await fetch(`${appOrigin}/process-otp?siteId=${siteId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token,
                    email: email,
                    brand: 'garage'
                })
            })

            if (!response.ok) {
                throw new Error('Failed to call OTP service')
            }

            const otpData = await response.json()

            if (!otpData || !otpData.success) {
                var err = otpData?.error_message || 'Failed to send OTP'
                throw new Error(err)
            }
        } catch (e) {
            const message =
                e.response?.status === 400
                    ? formatMessage(FEATURE_UNAVAILABLE_ERROR_MESSAGE)
                    : formatMessage(API_ERROR_MESSAGE)
            form.setError('global', {type: 'manual', message})
            // GTM Modification
            sendViewErrorEvent(message)
        }
    }

    const onSignoutClick = async () => {
        const token = await getTokenWhenReady()
        await fetch(`${appOrigin}/process-logout?siteId=${siteId}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({token})
        })
        await logout.mutateAsync()
        navigate('/login')
    }

    return (
        <Stack data-testid="account-detail-page" spacing={{base: 8, lg: 6}}>
            <Stack maxW={{base: '100%', lg: '457px'}}>
                <ResetPasswordForm
                    form={form}
                    submitForm={submitForm}
                    clickSignIn={onSignoutClick}
                    isAccountDashboard={true}
                    setShouldShowHeading={setShouldShowHeading}
                />
            </Stack>
        </Stack>
    )
}

ChangePassword.propTypes = {
    customerEmail: PropTypes.string
}

export default ChangePassword
